<template>
  <div class="d2-plan-card-item" :class="{ 'current': plansListFData.plan_f_text == '使用中' || plansListFData.plan_f_text == 'Using' }">
    <div class="d2-plan-card-name">{{ plansListFData.plan_f_title }}</div>
    <div class="d2-plan-card-price-row"><span class="d2-plan-card-price">${{ plansListFData.plan_f_label_amount }}</span><span class="d2-plan-card-unit">/{{lang['components']['Plan']['PlanF']['time_unit']}}</span></div>
    <ul class="d2-plan-card-features">
      <li v-for="(item, index) in description">
          <i class="fas fa-check"></i> {{ item }}
      </li>
    </ul>
    <button v-if="plansListFData.plan_f_show" class="d2-plan-card-btn upgrade" @click="handleChickPlan(143, 'F', '', 'fb')">
      {{ plansListFData.plan_f_text }}
    </button>
    <button v-else-if="!plansListFData.planHaveBind" class="d2-plan-card-btn upgrade" @click="handleChickPlan(143, 'F', '', 'fb')">
      {{lang['components']['Plan']['PlanF']['is_expired']}}
    </button>
    <button
      v-else
      class="d2-plan-card-btn payagain"
      v-if="isExpiredData && (plansListFData.plan_f_text == '使用中' || plansListFData.plan_f_text == 'Using')"
      @click="handleChickPlan(143, 'F', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanF']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanF',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListF:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      payError: true
    };
  },
  computed: {
    plansListFData: {
      get: function () {
        return this.plansListF
      },
      set: function (value) {
        this.$emit('update:plansListFData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListF.plan_f_description
    },
    isDisabled: function() {
       return this.plansListF.plan_f_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-F {
    &:hover {
      border: 2px #1D619F solid;
    }
  }
</style>
